// Importing images for Premier League clubs
import arsenal from "../assets/clubs/arsenal.png";
import aston from "../assets/clubs/aston.png";
import liverpool from "../assets/clubs/liv.png";
import utd from "../assets/clubs/utd.png";
import city from "../assets/clubs/city.png";
import chelsea from "../assets/clubs/chelsea.png";
import newcastle from "../assets/clubs/new.png";
import spurs from "../assets/clubs/spurs.png";
import westham from "../assets/clubs/westham.png";

// Importing images for La Liga clubs
import fcb from "../assets/clubs/fcb.png";
import madrid from "../assets/clubs/realmadrid.png";
import athletico from "../assets/clubs/athletico.png";
import girona from "../assets/clubs/girona.png";
import betis from "../assets/clubs/betis.png";
import sevilla from "../assets/clubs/sevilla.png";
import ath from "../assets/clubs/ath.png";
import villa from "../assets/clubs/villareal.png";

// Importing images for Ligue 1 clubs
import psg from "../assets/clubs/psg.png";
import lyon from "../assets/clubs/lyon.png";
import monaco from "../assets/clubs/monaco.png";
import nice from "../assets/clubs/nice.png";
import mars from "../assets/clubs/mars.png";
import sr from "../assets/clubs/sr.png";

// Importing images for Serie A clubs
import napoli from "../assets/clubs/napoli.png";
import roma from "../assets/clubs/roma.png";
import lazio from "../assets/clubs/lazio.png";
import juventus from "../assets/clubs/juventus.png";
import atalanta from "../assets/clubs/atalanta.png";
import inter from "../assets/clubs/inter.png";
import milan from "../assets/clubs/milan.png";

// Importing images for Bundesliga clubs
import bayerm from "../assets/clubs/bayern.png";
import bayer from "../assets/clubs/bayer.png";
import bvb from "../assets/clubs/bvb.png";
import union from "../assets/clubs/union.png";
import schalke from "../assets/clubs/sc.png";
import wolf from "../assets/clubs/wolf.png";

const pl = [
  {
    club: "Arsenal",
    Image: arsenal,
  },
  {
    club: "Chelsea",
    Image: chelsea,
  },
  {
    club: "Manchester United",
    Image: utd,
  },
  {
    club: "Manchester City",
    Image: city,
  },
  {
    club: "Tottenham",
    Image: spurs,
  },
  {
    club: "NewCastle United",
    Image: newcastle,
  },
  {
    club: "West Ham",
    Image: westham,
  },
  {
    club: "Aston Villa",
    Image: aston,
  },
  {
    club: "Liverpool",
    Image: liverpool,
  },
];

const laliga = [
  {
    club: "FC Barcelona",
    Image: fcb,
  },
  {
    club: "Real Madrid",
    Image: madrid,
  },
  {
    club: "Atletico Madrid",
    Image: athletico,
  },
  {
    club: "Girona FC",
    Image: girona,
  },
  {
    club: "Real Betis",
    Image: betis,
  },
  {
    club: "Sevilla FC",
    Image: sevilla,
  },
  {
    club: "Athletic Bilbao",
    Image: ath,
  },
  {
    club: "Villarreal CF",
    Image: villa,
  },
];

const ligue1 = [
  {
    club: "Paris Saint-Germain",
    Image: psg,
  },
  {
    club: "Lyon",
    Image: lyon,
  },
  {
    club: "AS Monaco",
    Image: monaco,
  },
  {
    club: "OGC Nice",
    Image: nice,
  },
  {
    club: "Marseille",
    Image: mars,
  },
  {
    club: "Stade Rennais",
    Image: sr,
  },
];

const bundesliga = [
  {
    club: "FC Bayern Munich",
    Image: bayerm,
  },
  {
    club: "Bayer Leverkusen",
    Image: bayer,
  },
  {
    club: "Borussia Dortmund",
    Image: bvb,
  },
  {
    club: "Union Berlin",
    Image: union,
  },
  {
    club: "FC Schalke 04",
    Image: schalke,
  },
  {
    club: "VfL Wolfsburg",
    Image: wolf,
  },
];

const seria = [
  {
    club: "Napoli",
    Image: napoli,
  },
  {
    club: "Roma",
    Image: roma,
  },
  {
    club: "Lazio",
    Image: lazio,
  },
  {
    club: "Juventus",
    Image: juventus,
  },
  {
    club: "Atalanta",
    Image: atalanta,
  },
  {
    club: "Inter Milan",
    Image: inter,
  },
  {
    club: "AC Milan",
    Image: milan,
  },
];

export { pl, laliga, ligue1, bundesliga, seria };
